import React from 'react';
import PropTypes from 'prop-types';
import { SquareArrowOutUpRight } from 'lucide-react';
import styles from './RelatedActions.module.css';

export const RelatedActions = ({ actions }) => {
  return (
    <div className={styles.container}>
      {/* <h3 className={styles.title}>Related:</h3>
      <div className={styles.actions}>
        {actions.map((action) => (
          <button 
            key={action.title}
            className={styles.actionButton}
            onClick={action.onClick}
          >
            <div className={styles.actionContent}>
              <span className={styles.actionTitle}>{action.title}</span>
              <SquareArrowOutUpRight className={styles.redirectIcon} size={16} />
            </div>
            {action.description && (
              <span className={styles.actionDescription}>{action.description}</span>
            )}
          </button>
        ))}
      </div> */}
    </div>
  );
};

RelatedActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};